<template>
    <div class="container offset">
        <div class="form-group">
            <div>{{data.text}}</div>
        </div>
        <!-- <div class="button-div d-flex flex-row-reverse">
            <a :href="data.link" target="_blank">
                <Button 
                    section="orange-outline"
                    value="Saiba mais"
                    :isOutline="true"
                    :hasIcon="true"
                    iconName="external-link-alt"
                /> 
            </a>
        </div> -->
    </div>
</template>

<script>
//import Button from '../../components/Button'

export default {
    name: "SobreConceitos",

    components: {
        //Button
    },

    props:{
        data: Object,
    },

    data (){
        return {

        }
    },
}

</script>

<style scoped>

    
</style>
